import { render } from "./CollabPupup.vue?vue&type=template&id=232b4c6e&scoped=true"
import script from "./CollabPupup.vue?vue&type=script&lang=js"
export * from "./CollabPupup.vue?vue&type=script&lang=js"

import "./CollabPupup.vue?vue&type=style&index=0&id=232b4c6e&lang=less&scoped=true"
import "./CollabPupup.vue?vue&type=style&index=1&id=232b4c6e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232b4c6e"]])

export default __exports__